import { render, staticRenderFns } from "./RoomNotSelected.vue?vue&type=template&id=d4b1b2b2"
import script from "./RoomNotSelected.vue?vue&type=script&lang=js"
export * from "./RoomNotSelected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports